import { symbolLabel, symbolSvg } from './taktischeSymbole'
import type { TaktikZeichen } from './taktischeSymbolUi'
import { GEOZONEN } from './kartenEbenen'
import type { LegendenEintrag } from './KartenDruck'

const punktSvg = (fuell: string, rand: string) =>
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 40" width="52" height="40"><circle cx="26" cy="20" r="9" fill="${fuell}" stroke="${rand}" stroke-width="3"/></svg>`
const flaecheSvg = (farbe: string, gestrichelt: boolean) =>
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 40" width="52" height="40"><rect x="6" y="7" width="40" height="26" fill="${farbe}" fill-opacity="0.25" stroke="${farbe}" stroke-width="3"${gestrichelt ? ' stroke-dasharray="6 4"' : ''}/></svg>`

/** Legende zur Druckauswahl: gesetzte Zeichen (je Bedeutung einmal), Einsatzort, Suchgebiete, Geozonen. */
export function legendeEintraege(o: {
  zeichen?: TaktikZeichen[]
  einsatzort?: boolean
  suchgebiete?: boolean
  geozonen?: string[]
}): LegendenEintrag[] {
  const out: LegendenEintrag[] = []
  const gesehen = new Set<string>()
  for (const z of o.zeichen ?? []) {
    const label = symbolLabel(z.typ)
    if (gesehen.has(label)) continue
    gesehen.add(label)
    out.push({ svg: symbolSvg(z.typ, z.kennung, z.organisation), label })
  }
  if (o.einsatzort) out.push({ svg: punktSvg('#dc2626', '#ffffff'), label: 'Einsatzort' })
  if (o.suchgebiete) out.push({ svg: flaecheSvg('#f59e0b', true), label: 'Suchgebiet' })
  for (const gz of GEOZONEN.filter(g => o.geozonen?.includes(g.key))) out.push({ svg: flaecheSvg(gz.farbe, false), label: gz.label })
  return out
}

/** Quellenangabe (ohne HTML) für den Seitenfuß */
export function quellenText(grundkarte: string, geozonen: boolean): string {
  const t: Record<string, string> = {
    karte: 'Karte: © OpenStreetMap-Mitwirkende',
    satellit: 'Luftbild: © Esri, Maxar, Earthstar Geographics',
    topo: 'Karte: © OpenTopoMap (CC-BY-SA), OpenStreetMap-Mitwirkende',
  }
  return [t[grundkarte], geozonen ? 'Geozonen: © DFS/DIPUL (§21h LuftVO)' : ''].filter(Boolean).join('  ·  ')
}
